import { create } from 'zustand';

const useUserStore = create((set, get) => ({
  initialized: false,
  user: null,
  setInitialized: (initialized) => set(() => ({ initialized })),
  setUser: (user) => set(() => ({ user })),
}));

export default useUserStore;
